import { UcoastEl } from '@/scripts/core/UcoastEl'
import {
	getAttributeOrThrow, getDistanceFromDocumentTop,
	qsaOptional,
	qsOptional,
} from '@/scripts/core/global'

export class ProductStickyNav extends UcoastEl {
	static htmlSelector = 'product-sticky-nav'
	scrollAreas: HTMLElement[]
	scrollAreaDistances: number[]
	startingHeight: number
	allowOnScroll: boolean
	currentIndex: number
	horizontalScroller?: HTMLElement
	constructor() {
		super()
		this.horizontalScroller = qsOptional('[data-horizontal-scroller]', this)
		this.currentIndex = 0
		this.allowOnScroll = false
		this.scrollAreas = []
		this.scrollAreaDistances = []
		this.startingHeight = this.getBoundingClientRect().height
		qsaOptional<HTMLButtonElement>('[data-scroll-trigger]', this)?.forEach(
			(button) => {
				const handle = getAttributeOrThrow(
					'data-scroll-trigger',
					button
				)
				const scrollArea = qsOptional(`[data-scroll-anchor=${handle}]`)
				if (scrollArea) {
					this.allowOnScroll = true
					this.scrollAreas.unshift(scrollArea)
					this.scrollAreaDistances.unshift(
						getDistanceFromDocumentTop(
							scrollArea,
							window.pageYOffset ||
								document.documentElement.scrollTop
						)
					)
				} else {
					button.remove()
				}
			}
		)
	}
	onHeaderScrollEvent(scrollTop: number) {
		if (!this.allowOnScroll) {
			return
		}
		let scrollAreaIndex = this.scrollAreaDistances.findIndex((distance) => {
			const topVal = scrollTop + this.startingHeight * 3
			return topVal >= distance
		})
		if (scrollAreaIndex < 0) {
			scrollAreaIndex = this.scrollAreas.length - 1
		}
		if (scrollAreaIndex === this.currentIndex) return
		this.currentIndex = scrollAreaIndex
		const scrollArea = this.scrollAreas[this.currentIndex]
		if (!scrollArea) {
			console.error('no scroll area found for index: ', this.currentIndex)
			return
		}
		const handle = getAttributeOrThrow('data-scroll-anchor', scrollArea)
		this.setActiveButton(handle)
	}
	setActiveButton(handle: string) {
		qsaOptional<HTMLButtonElement>('[data-scroll-trigger]', this)?.forEach(
			(button) => {
				const buttonHandle = getAttributeOrThrow(
					'data-scroll-trigger',
					button
				)
				if (handle === buttonHandle) {
					button.classList.add('active')
					this.scrollToItem(button)
				} else {
					button.classList.remove('active')
				}
			}
		)
	}
	scrollToItem(item: HTMLButtonElement) {
		const itemRect = item.getBoundingClientRect();
		const scroller = this.horizontalScroller ?? this;
		const containerRect = scroller.getBoundingClientRect();
		const offset = itemRect.left - containerRect.left;
		scroller.scrollLeft += offset - (containerRect.width / 2) + (itemRect.width / 2);
	}
}
